function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 3.5C5 2.39543 5.89543 1.5 7 1.5H17C18.1046 1.5 19 2.39543 19 3.5V4C19 4.27614 18.7761 4.5 18.5 4.5H5.5C5.22386 4.5 5 4.27614 5 4V3.5Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 6.5C2.89543 6.5 2 7.39543 2 8.5V17.5C2 18.6046 2.89543 19.5 4 19.5H5V20.5C5 21.6046 5.89543 22.5 7 22.5H17C18.1046 22.5 19 21.6046 19 20.5V19.5H20C21.1046 19.5 22 18.6046 22 17.5V8.5C22 7.39543 21.1046 6.5 20 6.5H4ZM15 9.5C14.4477 9.5 14 9.94771 14 10.5C14 11.0523 14.4477 11.5 15 11.5H18C18.5523 11.5 19 11.0523 19 10.5C19 9.94771 18.5523 9.5 18 9.5H15ZM7 15.5C7 14.9477 7.44772 14.5 8 14.5H16C16.5523 14.5 17 14.9477 17 15.5V19.5C17 20.0523 16.5523 20.5 16 20.5H8C7.44772 20.5 7 20.0523 7 19.5V15.5Z",
  fill: "currentColor"
});

var SvgPrinter = function SvgPrinter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrinter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/printer.29e0995f.svg";
export { ForwardRef as ReactComponent };